import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { useIdealCandidateContext } from '../../../utils/context';
import { Toggle } from '../../Toggle/Toggle';
import { Location } from './Location';
import { Timezone } from './Timezone';

export const LocationAndTimezone = () => {
  const { chosenCategory, setChosenCategory } = useIdealCandidateContext();
  return (
    <Stack direction="column" width="100%" gap="6">
      <Container maxWidth="270px">
        <Toggle isLocation={chosenCategory === 'location'} setChosenCategory={setChosenCategory} />
      </Container>
      {chosenCategory === 'location' && <Location />}
      {chosenCategory === 'timezone' && <Timezone />}
    </Stack>
  );
};
